import { useCallback, useEffect, useState } from 'react';
import { POCKETFLOWS_API_URL } from '../../constants/marketing';
import type { PocketflowsCustomer } from '../../types/marketing';

interface ConversionClickMessage {
  pocketflows?: boolean;
  action?: string;
  customer?: (Partial<PocketflowsCustomer> & { external_id?: string }) | null;
}

// Tracks the customer behind a conversion row clicked inside the Pocketflows ads embed
function useConversionCustomer() {
  const [customerId, setCustomerId] = useState<string | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== POCKETFLOWS_API_URL) return;

      const { pocketflows, action, customer } = (event.data ??
        {}) as ConversionClickMessage;
      if (!pocketflows || action !== 'conversionClick' || !customer) return;

      // eslint-disable-next-line no-underscore-dangle
      const porterId = customer.metadata?._porter_id || customer.external_id;
      if (!porterId) return;

      setCustomerId(porterId);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const clearCustomer = useCallback(() => setCustomerId(null), []);

  return { customerId, clearCustomer };
}

export default useConversionCustomer;
